require('./hireNewCreditCardError.scss');

import React from 'react';
import { i18n } from 'core/i18n';
import WizardError from 'components/commons/wizardError/wizardError';


import {
    KNOWN_ERROR_CODE,
    LOW_CREDIT_SCORE,
    REJECTED,
    HIRE_BLOCKED
} from 'constants/hireCardSubmitScenarios';

import { catalogue, analyticsId } from '../analytics/hireNewCreditCardViewAnalytics';
const { FormattedText, formatText } = i18n;

export const HireNewCreditCardError = ({
    hasAvailableAccounts,
    hireNewCreditCard,
    maxAllowedNumberCards,
    hireRestrictionFlag,
    processDetail,
}) => {
    const handleGoToDocumentation = () => {
        this.props.history.push('/myprofile/documentation');
    }

    const buildTexts = () => {
        let titleKey = "hireCardVanity-hireCardVanity_errorTitleGeneric";
        let textElement = (
            <div className="hire-card-neruda-error__text">
                <FormattedText value="hireCardVanity-hireCardVanity_errorTextGeneric" />
            </div>
        );
        if (__CONTACT_CENTER__ && !hasAvailableAccounts) {
            titleKey = 'hireCardOpenCredit-errorTitleNotAvailableAccounts';
            textElement = formatText('hireCards-errorTextNotAvailableAccounts');
        } else if (maxAllowedNumberCards) {
            titleKey = 'hireCreditErrors-hireCreditErrors_maxAllowedCardsHiredTitle';
            textElement = formatText('hireCreditErrors-hireCreditErrors_maxAllowedCardsHired');
        }
        if (hireRestrictionFlag) {
            titleKey = 'hireCard-errorRestrictionTitleAccount';
            textElement = <FormattedText value="hireCard-errorRestrictionSubtitleAccount" />;
        }

        switch (hireNewCreditCard.get('hiringStatus')) {
            case KNOWN_ERROR_CODE:
                titleKey = "hireCardVanity-hireCardVanity_errorTitleGeneric";
                textElement = (
                    <div>
                        <div className="hire-card-neruda-error__text hire-card-neruda-error__text--margin-bottom">
                            <FormattedText
                                value={`hireCreditErrors-${hireNewCreditCard.get('errorMsg')}`}
                            />
                        </div>
                        <div className="hire-card-neruda-error__text">
                            <FormattedText
                                value="hireNewCreditCard-errorTextRejected"
                            />
                        </div>
                    </div>
                );
                break;
            case REJECTED:
                titleKey = "hireCardVanity-hireCardVanity_errorTitleRejected";
                textElement = (
                    <div>
                        <div className="hire-card-neruda-error__text">
                            <FormattedText
                                value="hireNewCreditCard-errorTextRejected"
                            />
                        </div>
                    </div>
                );
                break;
            case LOW_CREDIT_SCORE:
                titleKey = "hireCardNeruda-errorTitleLowCreditScore_updated";
                const documentationLink = (
                    <a onClick={() => handleGoToDocumentation()} >
                        <FormattedText value="hireCardVanity-hireCardVanity_documentation" />
                    </a>
                );
                textElement = (
                    <div>
                        <div className="hire-card-neruda-error__text hire-card-neruda-error__text--margin-bottom">
                            <FormattedText value="hireCardNeruda-hireCardNeruda_lowCreditScoreMessage_updated_1" />
                            {documentationLink}
                            <FormattedText value="hireCardNeruda-hireCardNeruda_lowCreditScoreMessage_updated_2" />
                        </div>
                    </div>
                );
                break;
            case HIRE_BLOCKED:
                titleKey = "hireCardNeruda-errorTitleHireBlocked";
                textElement = (
                    <div>
                        <div className="hire-card-neruda-error__text">
                            <FormattedText value="hireCardNeruda-hireCardNeruda_hireBlockedMessage" />
                        </div>
                    </div>
                );
        }

        return {
            textElement,
            titleKey
        };
    }
    const { textElement, titleKey } = buildTexts();

    const goBackButton = {
        label: (
            <FormattedText
                format="uppercase"
                value="hireCards-backButtonLabel"
            />
        ),
        url: '/myprofile/cards'
    };

    return (
        <WizardError
            errorMessage={formatText(titleKey)}
            mainButton={goBackButton}
            processDetail={processDetail}
            tealium={catalogue[analyticsId.NERURA_CARD_WIZARD_ERROR]({
                productName: processDetail,
                errorMessage: formatText(titleKey),
            })}
            isSecondVersion
        >
            <article className="hire-card-neruda-error">
                {textElement}
            </article>
        </WizardError>
    );
};
